export const measuredCookieReduxKey = '@@measuredCookie';
export const actionKey = '@@measuredCookie';
export const cookieKey = 'td';

//# sourceMappingURL=constants.js.map